import { Input, Select, Space, Switch, Typography } from 'antd';
import type { FieldMeta } from '../../../api/types';
import type { VisibilityRule } from '../../../contract/types';

interface Props {
  rule: VisibilityRule | undefined;
  fieldMetas: FieldMeta[];
  onChange: (rule: VisibilityRule | undefined) => void;
}

const OPS = [
  { label: '有值时', value: 'notEmpty' },
  { label: '为空时', value: 'empty' },
  { label: '等于', value: 'eq' },
  { label: '不等于', value: 'ne' },
  { label: '包含', value: 'contains' },
] as const;

/** 条件显隐编辑：满足条件才在打印/导出/预览成品里显示该区块。 */
export function VisibilityRuleEditor({ rule, fieldMetas, onChange }: Props) {
  const enabled = !!rule;
  const needsValue = rule && (rule.op === 'eq' || rule.op === 'ne' || rule.op === 'contains');

  return (
    <div style={{ borderTop: '1px dashed var(--border-soft)', marginTop: 10, paddingTop: 8 }}>
      <Space style={{ marginBottom: enabled ? 8 : 0 }}>
        <Switch
          size="small"
          checked={enabled}
          onChange={(v) =>
            onChange(v ? { fieldId: '', op: 'notEmpty' } : undefined)
          }
        />
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>
          条件显示（满足才显示此区块）
        </Typography.Text>
      </Space>
      {enabled && rule && (
        <Space size={6} wrap>
          <Select
            size="small"
            style={{ width: 120 }}
            showSearch
            optionFilterProp="label"
            placeholder="字段"
            value={rule.fieldId || undefined}
            onChange={(v) => onChange({ ...rule, fieldId: v })}
            options={fieldMetas.map((m) => ({ label: m.name, value: m.id }))}
          />
          <Select
            size="small"
            style={{ width: 92 }}
            value={rule.op}
            onChange={(op) => onChange({ ...rule, op })}
            options={OPS as unknown as { label: string; value: string }[]}
          />
          {needsValue && (
            <Input
              size="small"
              style={{ width: 100 }}
              placeholder="比较值"
              value={rule.value ?? ''}
              onChange={(e) => onChange({ ...rule, value: e.target.value })}
            />
          )}
        </Space>
      )}
      {enabled && rule && !rule.fieldId && (
        <Typography.Text type="warning" style={{ fontSize: 11, display: 'block', marginTop: 4 }}>
          还没选字段，这条规则暂不生效（区块照常显示）。选了字段后才会按条件隐藏。
        </Typography.Text>
      )}
    </div>
  );
}
